import { cn } from "../../lib/utils";

const SPARKLES = [
  { top: "-16%", left: "4%", size: 10, delay: "0s", duration: "2.8s" },
  { top: "-10%", right: "8%", size: 9, delay: "0.45s", duration: "2.6s" },
  { top: "58%", left: "-7%", size: 8, delay: "0.9s", duration: "2.9s" },
  { top: "74%", right: "-6%", size: 10, delay: "1.35s", duration: "3s" },
  { top: "34%", right: "36%", size: 7, delay: "1.8s", duration: "2.5s" }
];

function SparkleGlyph() {
  return (
    <svg viewBox="0 0 24 24" className="h-full w-full fill-current" aria-hidden>
      <path d="M12 1.8c.52 0 .98.33 1.15.82l1.45 4.19a2 2 0 001.2 1.2l4.19 1.45a1.22 1.22 0 010 2.3l-4.19 1.45a2 2 0 00-1.2 1.2l-1.45 4.19a1.22 1.22 0 01-2.3 0l-1.45-4.19a2 2 0 00-1.2-1.2L3.01 11.75a1.22 1.22 0 010-2.3L7.2 8a2 2 0 001.2-1.2l1.45-4.19c.17-.49.63-.82 1.15-.82z" />
    </svg>
  );
}

export function SparklesText({ className, textClassName, children }) {
  return (
    <span className={cn("relative inline-flex items-center justify-center", className)}>
      <span
        className={cn(
          "relative z-10 inline-flex animate-gradient bg-[length:200%_200%] bg-clip-text text-transparent [background-image:linear-gradient(90deg,#67e8f9,#60a5fa,#34d399,#67e8f9)]",
          textClassName
        )}
      >
        {children}
      </span>

      <span aria-hidden className="pointer-events-none absolute -inset-3">
        {SPARKLES.map((sparkle, index) => (
          <span
            key={index}
            className="absolute text-cyan-200/90 drop-shadow-[0_0_10px_rgba(103,232,249,.45)]"
            style={{
              ...sparkle,
              width: `${sparkle.size}px`,
              height: `${sparkle.size}px`,
              animationName: "sparkle-pop",
              animationTimingFunction: "ease-in-out",
              animationIterationCount: "infinite",
              animationDelay: sparkle.delay,
              animationDuration: sparkle.duration
            }}
          >
            <SparkleGlyph />
          </span>
        ))}
      </span>
    </span>
  );
}
